module.exports = __webpack_public_path__ + "media/images/question-mark-2c1d2974bfccd755a9766c974d71ca81.png";